import styled from "styled-components";
import { responsive } from "theme/responsive";

export const ProductFeaturesWrapper = styled.section`
   display: grid;
   grid-template-columns: 40% 60%;
   padding: 3em 0;

   ${responsive("$small")`
   grid-template-columns: repeat(1, 1fr);
   gap: 2em;
   `}
`;
